import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService, TabDirective } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { ComboEstado } from '../../../core/model/combos';
import { DetalleSolicitud, SituacionSolicitud, TableContentInfo } from '../../../core/model/detalle-solicitud';
import { FlujoAprobaciones } from '../../../core/model/flujo-aprobaciones';
import { SolicitudMaterial } from '../../../core/model/solicitud-materiales';
import { SolicitudesAprobadas } from '../../../core/model/solicitudes';
import { AlbaranService } from '../../../core/services/albaran.service';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { ClientesService } from '../../../core/services/clientes.service';
import { DetalleService } from '../../../core/services/Detalle/detalle.service';
import { FlujoAprobacionesService } from '../../../core/services/flujo-aprobaciones.service';
import { PopulateService } from '../../../core/services/populate.service';
import { ProveedoresService } from '../../../core/services/proveedores.service';
import { SolicitudesService } from '../../../core/services/solicitudes.service';
import { UtilitiesService } from '../../../core/services/Utility/utilities.service';
import { ChangeProveedorSolicitudComponent } from '../change-proveedor-solicitud/change-proveedor-solicitud.component';
import { ChangeoptionsSolicitudComponent } from '../changeoptions-solicitud/changeoptions-solicitud.component';

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.css'],
  providers: [SolicitudesService]
})
export class DetalleComponent implements OnInit, OnDestroy, AfterViewChecked {
  id: number;

  modalRef: BsModalRef;
  Boxtype = 'box-primary';
  Title: string;
  Description: string;
  Padre: string;
  Hijo: string;

  isDocoutUser: boolean;
  isAdminUser: boolean;
  isGestorUser: boolean;
  // 🥑🥑 SRR para controlar el nombre de usuario
  nombreUsuarioCreacion: string;

  statusCode: number;
  requestProcessing = false;
  requestContent = false;
  noData = false;
  mensajeToShow: string;
  mensajeToShow2: string;

  finalizado = false;

  @ViewChild('tblcontent') table: any;
  viewDetails: DetalleSolicitud;
  viewDetailsCont: DetalleSolicitud;

  tieneOriginalCopia = false;
  esActualUrgente = false;
  esActualOriginal = false;

  private subscription;
  private subscription_change;
  private subscription_detail;
  private subscription_state;
  private subscription_get;

  isLoadingContents = true;


  idestado: number;
  idsituacion: number;
  isFinalizada = true;
  isNueva = false
  hasMoreThanOneTable: boolean;

  // ngx-datatable
  lineacontenido: any;
  columns = [];
  columns_multivalue = [];
  rows = [];
  noDataContent = false;
  thinking = false;
  hasAutorizaciones: boolean;

  approvingUsers: FlujoAprobaciones[];
  approvingGroup: FlujoAprobaciones[];

  // detalle contenido
  contabilidad = [];
  single_selected: TableContentInfo;

  //proveedorContenido
  proveedorCont: string;
  idProveedorCont: number;
  correoProveedorCont: string;
  telefonoProveedorCont: string;
  contactoProveedorCont: string;
  contenidoSeleccionadoMostrado = false;

  rowsContenidosNoInventariados: TableContentInfo[];
  rowsContenidosExpedientes: TableContentInfo[];
  rowsContenidosContenedores: TableContentInfo[];
  rowsContenidosAZs: TableContentInfo[];
  rowsMateriales: SolicitudMaterial[];

  isMaterialRequested = false;

  contenidoSeleccionado: number;

  // ngx-datatable options
  customMessages = {
    emptyMessage: 'No hay solicitudes disponibles',
    totalMessage: 'Total',
    selectedMessage: 'Selección'
  };
  customClasses = {
    sortAscending: 'fas fa-sort-up',
    sortDescending: 'fas fa-sort-down',
    pagerLeftArrow: 'fas fa-chevron-left',
    pagerRightArrow: 'fas fa-chevron-right',
    pagerPrevious: 'fas fa-step-backward',
    pagerNext: 'fas fa-step-forward'
  };

  contenidoFiles = [];
  requestFiles = [];
  idContenido: number;

  downloadingAlbaran = false;
  albaranBlobUrl = undefined;
  isIE = window.navigator && window.navigator.msSaveOrOpenBlob;

  hasFilesShareable = false;

  requestFilesDocumentation = [];
  reload = false;
  reloadObservations = false;

  // 🥑🥑 SRR Masiva
  requestFilesMassiveLoad = [];
  cbEstado: ComboEstado[];
  isCancelled = false;
  idestado_original: number;
  errorcomboestado = false;
  errorcombosituacion = false;
  errorcomboestadocontenido = false;
  summaryerror = false;
  idsituacion_original: number;
  cbSituacion: SituacionSolicitud[];
  allSituaciones: SituacionSolicitud[];
  loadingCancelarSolicitud = false;

  //🥑🥑 proveedor solicitud
  isProveedorDocout = false;
  tieneProveedores = false;
  tienePermisoCambiarProveedores = false;

  //🥑🥑 proveedor contenido
  isProveedorDocoutCont = false;
  tieneProveedoresCont = false;
  tienePermisoCambiarProveedoresCont = false;

  //🥑🥑 variable para controlar que las situaciones estan recuperadas y cargar el combo
  isLoadingSituaciones = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private authService: AuthenticationService,
    private detalleservice: DetalleService,
    private router: Router,
    private toastr: ToastrService,
    private flujoAprobacionesService: FlujoAprobacionesService,
    private modalservice: BsModalService,
    private solicitudeservice: SolicitudesService,
    private cdRef: ChangeDetectorRef,
    private albaranService: AlbaranService,
    private utilitiesService: UtilitiesService,
    private clientesService: ClientesService,
    //🥑🥑 SRR MASIVA
    private populateService: PopulateService,
    //🥑🥑 PROVEEDORES
    private proveedoresService: ProveedoresService,


  ) { }

  ngOnInit() {
    this.load();
  }

  load() {
    this.SetEnviroment();
    // this.InitLanguage();
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.id = +params.get('id');
      const contenidoSeleccionado = params.get('contenidoSeleccionado');
      this.contenidoSeleccionado = contenidoSeleccionado ? parseInt(contenidoSeleccionado, 10) : undefined;

      if (this.id) {
        this.getDetailsSolicitud();
      } else {
        this.router.navigate(['docout', { outlets: { contenido: ['panelmando'] } }]);
      }
    });
    this.hasAutorizaciones = this.authService.hasAutorizaciones();
    this.setAdminUser();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  setAdminUser() {
    this.isAdminUser = this.authService.isAdminUser();
  }
  setGestorUser() {
    if (this.viewDetails.ID_SERIE != null || this.viewDetails.ID_SERIE != undefined) {
      this.authService.isGestionador(this.viewDetails.ID_SERIE).subscribe(result => this.isGestorUser == result);
    } else {
      this.isGestorUser == false;
    }
    
  }
  SetEnviroment() {
    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        this.isDocoutUser = isDocUser;
      });
  }

  cancelarSolicitud() {
    this.loadingCancelarSolicitud = true;
    this.solicitudeservice.cancelarSolicitudInicial(this.id).subscribe(
      (p) => {
        this.loadingCancelarSolicitud = false;
        if (!p.isok) {
          this.toastr.warning(
            'Ha ocurrido un error al intentar cancelar la solicitud. Mas info: ' + p.msg);
        } else {
          this.toastr.success('Se ha cancelado correctamente la solicitud');
          this.load();
        }
      },
      () => {
        this.loadingCancelarSolicitud = false;
      }
    );
  }

  InitLanguage() {
    this.subscription = this.translateService.get(['detalle'])
      .subscribe(values => { this.TranslateText(values); });

    this.subscription_change = this.translateService.onLangChange.subscribe(() => {
      this.translateService.get(['detalle'])
        .subscribe(values => { this.TranslateText(values); });
    });
  }

  TranslateText(values: any) {

  }


  ngOnDestroy() {
    // console.log('Clear detalle cliente');
    if (!this.subscription == null) { this.subscription.unsubscribe(); }
    if (!this.subscription_change == null) { this.subscription_change.unsubscribe(); }
    if (!this.subscription_detail == null) { this.subscription_detail.unsubscribe(); }
    if (!this.subscription_state == null) { this.subscription_state.unsubscribe(); }
    if (!this.subscription_get == null) { this.subscription_get.unsubscribe(); }
  }


  onSelect(row) {
    this.idContenido = row.contenidoId;
    this.single_selected = row;
    this.contenidoFiles = this.getContentImages(this.idContenido);

    // 🥑🥑 proveedor contenido
    if (row.proveedor == null) {
      this.isProveedorDocoutCont = true;
    } else {
      this.isProveedorDocoutCont = false;
      this.proveedorCont = row.proveedor;
      this.idProveedorCont = row.idProveedor;
      this.correoProveedorCont = row.correoProveedor;
      this.telefonoProveedorCont = row.telefonoProveedor;
      this.contactoProveedorCont = row.contactoProveedor;
      this.contenidoSeleccionadoMostrado = true;
      this.usuarioTienePermisoCambioProveedorCont(this.authService.getUserId(), this.idProveedorCont);
    }
  }

  loadContenido() {
  }

  /**
   * Obtención de guid, fecha y nombre de todos los ficheros del contenido contentId
   * @param contentId Id del contenido cuyos GUID se desea recuperar
   */
  getContentImages(contentId: number): any[] {
    if (!contentId) {
      return [];
    }
    const content = this.getContentByIdContents(contentId);
    return !content || !content.ficheros ? null : content.ficheros
      .map(fichero => {
        return {
          guid: fichero.GUID, name: fichero.NOMBRE_FICHERO,
          date: new Date(fichero.FECHA)
        };
      });
  }


  getDetailsSolicitud() {
    this.thinking = true;
    this.preProcessDetails('Recuperando detalle de la solicitud');
    this.isLoadingContents = true;
    this.subscription_detail = this.detalleservice.getViewDetails(this.id)
      .subscribe(contenido => {
        this.thinking = false;
        this.viewDetails = contenido;
        this.setGestorUser();
        if (this) {
          this.getContentImages(+this.idContenido);
        }
        this.requestFilesMassiveLoad = contenido.FicherosCargaMasiva.map(fichero => {
          return { guid: fichero.GUID, name: fichero.NOMBRE_FICHERO, date: fichero.FECHA };
        });
        this.requestFilesDocumentation = contenido.FicherosDocumentacion.map(fichero => {
          return { guid: fichero.GUID, name: fichero.NOMBRE_FICHERO, date: fichero.FECHA };
        });
        if (!this.viewDetails) {
          this.noData = true;
        } else {
          this.isMaterialRequested = this.viewDetails.ID_SERIE == null;
          this.getEstado(this.viewDetails.ID_CLIENTE, this.viewDetails.ID_TIPO_SERVICIO);
        }
        this.reloadAuthorization();
        this.requestProcessing = false;
        if (contenido.ESTADO_GEN_SERVICIO == undefined || contenido.ESTADO_GEN_SERVICIO == 0 || contenido.ESTADO_GEN_SERVICIO == 2) {
          this.isFinalizada = false;
        }
        this.clientesService.getAreFilesShareable(this.viewDetails.ID_CLIENTE).pipe(first())
          .subscribe(result => {
            this.hasFilesShareable = result;
          });

        if (this.viewDetails.ID_PROVEEDOR == null) {
          this.isProveedorDocout = true;
        } else {
          this.isProveedorDocout = false;
        };

        //🥑🥑 proveedor
        this.clienteTieneProveedores(this.viewDetails.ID_CLIENTE);
        this.usuarioTienePermisoCambioProveedor(this.viewDetails.ID_PROVEEDOR);

      },
        errorCode => {
          this.errorCode();
        });
  }


  private isMaterialsRequest() {
    return this.viewDetails.ID_SERIE == null;
  }
  preProcessDetails(mensaje: string) {
    this.mensajeToShow = mensaje;
    this.statusCode = null;
    this.requestProcessing = true;
  }

  preProcessContent(mensaje: string) {
    this.mensajeToShow2 = mensaje;
    this.statusCode = null;
    this.requestContent = true;
  }

  errorCode() {
    this.detalleservice.hasMulticlientPermissions(this.id)
      .subscribe((clientName: string) => {
        this.thinking = false;
        if (!!clientName) {
          const popupMessage: string = this.translateService.instant('mensajes.nopermissionsclientbyrequest')
            .replace('{{CLIENT_NAME}}', clientName);

          localStorage.setItem('popupMessageDashboard', popupMessage);
          this.router.navigate([
            'docout',
            {
              outlets: {
                contenido: ['panelmando']
              }
            }
          ]);
          return;
        }
        this.toastr.warning(this.translateService.instant('mensajes.nodata'),
          this.translateService.instant('mensajes.nodatatitle'));
        this.router.navigate(['/notfound']);

      },
        errorCode => {
          this.thinking = false;
        });
  }

  onSelectTab(data: TabDirective): void {
    switch (data.id) {
      case 'tabdetalle':
        break;
      case 'tabobservaciones':
        this.reloadObservations = !this.reloadObservations;
        break;
      case 'tabhistorico':
        this.reload = !this.reload;
        break;
      case 'tabAutorizacion':
        this.reloadAuthorization();
        break;
      default:
        break;
    }
  }

  private reloadAuthorization() {
    this.flujoAprobacionesService.getAllAprobaciones(this.id)
      .subscribe((response: FlujoAprobaciones[]) => {
        this.approvingUsers = this.sortFlujoAprobacionesByFechaAprobacion(response);
        this.approvingGroup = this.approvingGroup ? [...this.approvingGroup] : undefined;
        if (!this.approvingUsers.some(resp => !resp.APROBADA)) {
          if (this.viewDetails.ID_USUARIO_APROBACION && this.viewDetails.ID_USUARIO_APROBACION > 0) {
            const newApprovingFlow: FlujoAprobaciones = {
              APROBADA: null,
              USUARIO_SUPERVISION: this.viewDetails.USUARIO_APROBACION,
              FECHA_APROBACION: null,
              NOMBRE_USUARIO_SUPERVISION: this.viewDetails.NOMBREYAPES_USUARIO_APROBACION
            };

            this.approvingUsers = [...this.approvingUsers, newApprovingFlow];
          } else if (this.viewDetails.GRUPO_APROBACION) {
            const newApprovingGroupFlow: FlujoAprobaciones = {
              APROBADA: null,
              USUARIO_SUPERVISION: this.viewDetails.GRUPO_APROBACION.NOMBRE,
              FECHA_APROBACION: null,
              NOMBRE_USUARIO_SUPERVISION: this.viewDetails.GRUPO_APROBACION.DESCRIPCION,
              ID_USUARIO_SUPERVISION: this.viewDetails.RANGO_APROBACION
            };
            this.approvingGroup = [newApprovingGroupFlow];
          }
        }
      });
  }

  private sortFlujoAprobacionesByFechaAprobacion(response: FlujoAprobaciones[]): FlujoAprobaciones[] {
    return response.sort(function (a, b) {
      const dateA: any = new Date(a.FECHA_APROBACION);
      const dateB: any = new Date(b.FECHA_APROBACION);
      return dateA - dateB;
    });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalservice.show(template);
  }

  aprobarSolicitud(approved: number) {
    this.thinking = true;
    this.solicitudeservice.aprobarSolicitud(this.id, approved)
      .subscribe((response: SolicitudesAprobadas) => {
        this.thinking = false;
        this.viewDetails.ID_USUARIO_APROBACION = response.ID_USUARIO_APROBACION;
        this.viewDetails.USUARIO_APROBACION = response.USUARIO_APROBACION;
        this.viewDetails.GRUPO_APROBACION = undefined;
        this.viewDetails.RANGO_APROBACION = undefined;
        this.approvingGroup = undefined;
        this.reloadAuthorization();
        this.getDetailsSolicitud();
        this.closeModal();
      }, error => {
        this.thinking = false;
      });
  }

  closeModal() {
    this.modalRef.hide();
  }



  downloadAlbaran() {
    this.downloadingAlbaran = true;
    this.albaranService.getAlbaranSolicitudBlob(this.id).subscribe(data => {
      const albaranBlob = new Blob([data], { type: 'application/pdf' });
      if (this.isIE) {
        window.navigator.msSaveOrOpenBlob(albaranBlob, this.id + '.pdf');
      } else {
        this.albaranBlobUrl = window.URL.createObjectURL(albaranBlob);
        this.downloadingAlbaran = false;
      }
    },
      error => {
        this.downloadingAlbaran = false;
      });
  }

  setContenidosNoInventariados(contenidosNoInventariados: TableContentInfo[]) {
    this.rowsContenidosNoInventariados = contenidosNoInventariados;
  }

  setContenidosExpedientes(contenidosExpedientes: TableContentInfo[]) {
    this.rowsContenidosExpedientes = contenidosExpedientes;
  }

  setContenidosContenedores(contenidosContenedores: TableContentInfo[]) {
    this.rowsContenidosContenedores = contenidosContenedores;
  }

  setContenidosAZs(contenidosAZs: TableContentInfo[]) {
    this.rowsContenidosAZs = contenidosAZs;
  }

  private getContentByIdContents(contentId): TableContentInfo {
    const rowNoInventariadas = this.rowsContenidosNoInventariados.find(row => row.contenidoId == contentId);
    if (rowNoInventariadas) {
      return rowNoInventariadas;
    }
    const rowExpedientes = this.rowsContenidosExpedientes.find(row => row.contenidoId == contentId);
    if (rowExpedientes) {
      return rowExpedientes;
    }

    const rowContenedores = this.rowsContenidosContenedores.find(row => row.contenidoId == contentId);
    if (rowContenedores) {
      return rowContenedores;
    }

    const rowAZs = this.rowsContenidosAZs.find(row => row.contenidoId == contentId);
    if (rowAZs) {
      return rowAZs;
    }

    return null;
  }

  private hasContents() {
    if (this.isMaterialsRequest()) {
      return this.rowsContenidosNoInventariados.length > 0;
    }
    const hasDataNoInventariados = this.rowsContenidosNoInventariados && this.rowsContenidosNoInventariados.length > 0;
    const hasDataExpedientes = this.rowsContenidosExpedientes && this.rowsContenidosExpedientes.length > 0;
    const hasDataContenedores = this.rowsContenidosContenedores && this.rowsContenidosContenedores.length > 0;
    const hasDataAz = this.rowsContenidosAZs && this.rowsContenidosAZs.length > 0;
    return hasDataNoInventariados || hasDataExpedientes || hasDataContenedores || hasDataAz;
  }


  hasAllContents(hasAllContents: boolean) {
    if (hasAllContents) {
      this.noDataContent = !this.hasContents();
      this.thinking = false;
      this.requestContent = false;
      this.requestProcessing = false;
      this.isLoadingContents = false;
    } else {
      this.isLoadingContents = false;
    }
  }

  resetSelect(reset: boolean) {
    if (reset) {
      this.single_selected = undefined;
    }
  }

  descargarDetalleSolicitud() {
    this.isLoadingContents = true;
    this.solicitudeservice.descargarDetalleSolicitud(this.id).pipe(first())
      .subscribe(data => {
        this.isLoadingContents = false;
        this.utilitiesService.downloadGenericFile(`${this.id}.pdf`, data);
      },
        error => {
          this.isLoadingContents = false;
          this.toastr.error(this.translateService.instant('solicitudes.detailDownloadError'));
        });
  }

  onResized(table, event: any): void {
    if (table) {
      setTimeout(() => {
        table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  showModalChangeOptions() {

    const modal = this.modalservice.show(ChangeoptionsSolicitudComponent, { backdrop: 'static', keyboard: false });
    (<ChangeoptionsSolicitudComponent>modal.content).showConfirmationModal(
      'Cambiar opciones',
      'Seleccione los cambios que desea mediante los desplegables',
      this.id,
      this.tieneOriginalCopia,
      this.viewDetails.NORMAL_URGENTE == 'URGENTE',
      this.viewDetails.NOMBRE_PARAM_SERVICIO == 'ORIGINAL'
    );
    (<ChangeoptionsSolicitudComponent>modal.content).onClose.subscribe(result => {
      if (!result) {
        return;
      }
    });
    if (this.viewDetails.NORMAL_URGENTE == 'URGENTE') {
      this.esActualUrgente = true;
    } else {
      this.esActualUrgente = false;
    }
    if (this.viewDetails.NOMBRE_PARAM_SERVICIO == 'ORIGINAL') {
      this.esActualOriginal = true;
    } else {
      this.esActualOriginal = false;
    }
    (<ChangeoptionsSolicitudComponent>modal.content).onSaveCambios.subscribe(datos => {
      if (this.esActualUrgente != datos.normalurgente) {
        // cambios urgente normal
        this.solicitudeservice.actualizarUrgenteNormalSolicitud(this.id, datos.normalurgente)
          .subscribe(
            (p) => {
              this.toastr.success('Se ha actualizado el MODO de la solicitud.');
              if (this.esActualOriginal != datos.originalcopia) {
                // cambios original copia
                this.solicitudeservice.actualizarOriginalCopiaSolicitud(this.id, datos.originalcopia)
                  .subscribe(
                    (z) => {
                      // 🐱‍👤 Metodo para refrescar las opciones de la solicitud
                      this.toastr.success('Se ha actualizado el TIPO de la solicitud.');
                      this.getDetailsSolicitud();
                      this.thinking = false;
                    },
                    (err: HttpErrorResponse) => {
                      // this.toastr.error('Ha ocurrido un problema al actualizar las opciones del servicio COPIA/ORIGINAL.' +
                      //    ' Vuelva a intentarlo pasados unos segundos o póngase en contacto con soporte');
                      // tslint:disable-next-line: max-line-length
                      this.toastr.error('No se ha podido actualizar la solicitud, compruebe que sea un prestamo y vuelvalo a intentar en unos minutos.');
                      this.thinking = false;
                    }
                  );
              }
              {
                this.getDetailsSolicitud();
                this.thinking = false;
              }
            },
            (err: HttpErrorResponse) => {
              // this.toastr.error('Ha ocurrido un problema al actualizar las opciones del servicio NORMAL/URGENTE.' +
              //    ' Vuelva a intentarlo pasados unos segundos o póngase en contacto con soporte');
              this.toastr.error('No se ha podido actualizar la solicitud.');
              this.thinking = false;
            }
          );
      } else if (this.esActualOriginal != datos.originalcopia) {
        // cambios original copia
        this.solicitudeservice.actualizarOriginalCopiaSolicitud(this.id, datos.originalcopia)
          .subscribe(
            (z) => {
              // 🐱‍👤 Metodo para refrescar las opciones de la solicitud
              this.getDetailsSolicitud();
              this.toastr.success('Se ha actualizado el TIPO de la solicitud.');
              this.thinking = false;
            },
            (err: HttpErrorResponse) => {
              // this.toastr.error('Ha ocurrido un problema al actualizar las opciones del servicio COPIA/ORIGINAL.' +
              //    ' Vuelva a intentarlo pasados unos segundos o póngase en contacto con soporte');
              // tslint:disable-next-line: max-line-length
              this.toastr.error('No se ha podido actualizar la solicitud, compruebe que sea un prestamo y vuelvalo a intentar en unos minutos.');
              this.thinking = false;
            }
          );
      } else {
        this.toastr.info('No se ha solicitado ningun cambio.');
      }
    });

  }
  preCargaModalParaCopiaOriginal() {
    this.solicitudeservice.comprobarTieneCopiaOriginal(this.viewDetails.ID_CLIENTE)
      .subscribe(
        (r: boolean) => {
          this.tieneOriginalCopia = true;
          // Modal
          this.showModalChangeOptions();
        },
        (e: Error) => {
          this.tieneOriginalCopia = false;
          this.toastr.error('El cliente no tiene servicio COPIA y ORIGINAL => ' + e.message);
        }
      );
  }

  // 🥑🥑 SRR 27/11/2020 MASIVAS
  canUploadContents(): boolean {
    if (this.viewDetails && this.cbEstado && !this.isCancelled) {

      this.authService.getUserName().subscribe(data => {
        this.nombreUsuarioCreacion = data;
      });

      if (this.isAdminUser || this.nombreUsuarioCreacion == this.viewDetails.NOMBRE_USUARIO_SOLICITANTE) {
        const estado = this.cbEstado.find(st => st.ID === +this.idestado_original);
        return this.viewDetails.NOMBRE_TIPO_SERVICIO !== 'MATERIALES' && estado.NOMBRE.toUpperCase() !== 'FINALIZADA';
      }
    }
    return false;
  }

  getEstado(idcliente: number, idtiposervicio: number) {
    this.subscription_state = this.populateService.getComboEstado(idcliente, idtiposervicio, this.id)
      .subscribe(
        estados => {
          this.cbEstado = estados;
          if (this.isDocoutUser) {
            this.idestado = this.viewDetails.ID_ESTADO_DOCOUT;
            this.idestado_original = this.viewDetails.ID_ESTADO_DOCOUT;
          } else {
            this.idestado = this.viewDetails.ID_ESTADO_CLIENTE;
            this.idestado_original = this.viewDetails.ID_ESTADO_CLIENTE;
          }
          const stateSelected = this.cbEstado.find(x => x.ID == this.idestado);
          if (stateSelected) {
            this.isFinalizada = stateSelected.IsFinalize;
            this.isCancelled = stateSelected.IsCanceled;
            this.isNueva = stateSelected.TIPO === 'INICIAL';
          }

          if (this.cbEstado.length <= 0) {
            this.summaryerror = true;
            this.errorcomboestado = true;
            this.cbEstado.push({
              ID: this.viewDetails.ID_ESTADO_DOCOUT,
              NOMBRE: this.viewDetails.NOMBRE_ESTADO_DOCOUT,
              TIPO: '',
              IsFinalize: false,
              IsCanceled: false,
              IsIncidencia: false
            });
          }
          this.getSituacion(this.viewDetails.ID_TIPO_SERVICIO);

        },
        errorCode => {
          this.cbEstado = [];
          this.errorCode();
        });
  }

  getSituacion(idtiposervicio: number) {
    this.isLoadingSituaciones = true;
    this.subscription_state = this.detalleservice.getSituacionesByService(idtiposervicio)
      .subscribe(
        situaciones => {
          this.allSituaciones = situaciones;
          if (this.isDocoutUser) {
            this.idsituacion = this.viewDetails.ID_SITUACION_DOCOUT;
            this.idsituacion_original = this.viewDetails.ID_SITUACION_DOCOUT;
          } else {
            this.idsituacion = this.viewDetails.ID_SITUACION_CLIENTE;
            this.idsituacion_original = this.viewDetails.ID_SITUACION_CLIENTE;
          }
          this.cbSituacion = situaciones.filter(sit => sit.ESTADO.Id == this.idestado);

          if (this.cbSituacion.length <= 0) {
            this.summaryerror = true;
            this.errorcombosituacion = true;
          }
          this.isLoadingSituaciones = false;
        },
        errorCode => {
          this.isLoadingSituaciones = false;
          this.cbSituacion = [];
          this.errorCode();
        });
  }

  //🥑🥑 saber si tiene proveedores
  clienteTieneProveedores(idCliente: number) {

    this.proveedoresService.TieneProveedoresCliente(idCliente)
      .subscribe(result => {
        this.tieneProveedores = result;
      },
        (e: Error) => {
          this.tieneProveedores = false;
          this.toastr.error('Error a la hora de recuperar los proveedores del cliente => ' + e.message);
        }
      );
  }

  //🥑🥑 saber si el usuario tiene algun grupo que tenga asociado el ID_PROVEEDOR
  usuarioTienePermisoCambioProveedor(idProveedor: number) {
    this.proveedoresService.TienePermisoCambioProveedor(idProveedor)
      .subscribe((result) => {
        this.tienePermisoCambiarProveedores = result;
      },
        (e: Error) => {
          this.tienePermisoCambiarProveedores = false;
          this.toastr.error('Error recuperando el permiso para cambiar de proveedor => ' + e.message);
        }
      );
  }

  // 🥑🥑 saber si el usuario tiene algun grupo que tenga asociado el ID_PROVEEDOR del contenido
  usuarioTienePermisoCambioProveedorCont(idUsuario: number, idProveedor: number) {
    this.proveedoresService.TienePermisoCambioProveedor(idProveedor)
      .subscribe((result) => {
        this.tienePermisoCambiarProveedoresCont = result;
      },
        (e: Error) => {
          this.tienePermisoCambiarProveedoresCont = false;
          this.toastr.error('Error recuperando el permiso para cambiar de proveedor en el contenido => ' + e.message);
        }
      );
  }

  //🥑🥑 show modal cambio proveedor
  showModalChangeProveedor() {
    const modal = this.modalservice.show(ChangeProveedorSolicitudComponent, { backdrop: 'static', keyboard: false });
    (<ChangeProveedorSolicitudComponent>modal.content).showConfirmationModal(
      'Cambiar proveedor',
      'Seleccione el nuevo proveedor mediante el desplegable.',
      this.viewDetails.ID_CLIENTE,
      this.viewDetails.ID_PROVEEDOR,
      this.allSituaciones
    );
    (<ChangeProveedorSolicitudComponent>modal.content).onClose.subscribe(result => {
      return;
    });
    (<ChangeProveedorSolicitudComponent>modal.content).onSaveCambios.subscribe(datos => {

      if (datos.idProveedorFinal == undefined) {
        this.toastr.info('No se ha recuperado el proveedor seleccionado de forma correcta.');
      }
      else if (this.viewDetails.ID_PROVEEDOR != datos.idProveedorFinal) {

        this.proveedoresService.ActualizarIdProveedorSolicitud(this.id, datos.idProveedorFinal, datos.observacionesCambio, datos.situacionFinalTraza)
          .subscribe(
            (p) => {
              this.toastr.success('Se ha actializado el proveedor de la solicitud.');
              if (!this.isDocoutUser) {
                this.router.navigate(['docout', { outlets: { contenido: ['panelmando'] } }]);
              }
              else{
              this.getDetailsSolicitud();
              this.thinking = false;
              }
            },
            (err: HttpErrorResponse) => {
              this.toastr.error('No se ha podido actualizar la solicitud.');
              this.thinking = false;
            }
          );
      }
      else {
        this.toastr.info('El proveedor seleccionado es el actual de la solicitud.');
      }
    });

  }

  //🥑🥑 cargar modal
  preCargaModalParaCambioProveedor() {
    this.proveedoresService.TieneMasProveedoresCliente(this.viewDetails.ID_CLIENTE, this.viewDetails.ID_PROVEEDOR)
      .subscribe(
        (p) => {
          // Modal
          this.showModalChangeProveedor();
        },
        (e: Error) => {
          this.toastr.error('El cliente no tiene mas proveedores asociados => ' + e.message);
        }
      );
  }

  private convertValuesToCSVRow(values: any[]): string {
    return values.join(';') + '\n';
  }

  // 🥑🥑 cargar modal del contenido
  preCargaModalParaCambioProveedorCont() {
    this.proveedoresService.TieneMasProveedoresCliente(this.viewDetails.ID_CLIENTE, this.viewDetails.ID_PROVEEDOR)
      .subscribe(
        (p) => {
          // Modal
          this.showModalChangeProveedorCont();
        },
        (e: Error) => {
          this.toastr.error('El cliente no tiene más proveedores asociados => ' + e.message);
        }
      );
  }

  // 🥑🥑 show modal cambio proveedor del contenido
  showModalChangeProveedorCont() {
    const modal = this.modalservice.show(ChangeProveedorSolicitudComponent, { backdrop: 'static', keyboard: false });
    (<ChangeProveedorSolicitudComponent>modal.content).showConfirmationModal(
      'Cambiar proveedor del contenido',
      'Seleccione el nuevo proveedor mediante el desplegable.',
      this.viewDetails.ID_CLIENTE,
      this.viewDetails.ID_PROVEEDOR,
      this.allSituaciones
    );
    (<ChangeProveedorSolicitudComponent>modal.content).onClose.subscribe(result => {
      return;
    });
    (<ChangeProveedorSolicitudComponent>modal.content).onSaveCambios.subscribe(datos => {

      if (datos.idProveedorFinal == undefined) {
        this.toastr.info('No se ha recuperado el proveedor seleccionado de forma correcta.');
      } else if (this.viewDetails.ID_PROVEEDOR != datos.idProveedorFinal) {

        this.proveedoresService.ActualizarIdProveedorContenido(this.idContenido, datos.idProveedorFinal, datos.observacionesCambio, datos.situacionFinalTraza)
          .subscribe(
            (p) => {
              this.toastr.success('Se ha actualizado el proveedor del contenido.');
              if (!this.isDocoutUser) {
                this.router.navigate(['docout', { outlets: { contenido: ['panelmando'] } }]);
              }
              else {
                this.getDetailsSolicitud();
                this.contenidoSeleccionadoMostrado = false;
                this.thinking = false;
              }
            },
            (err: HttpErrorResponse) => {
              this.toastr.error('No se ha podido actualizar el contenido.');
              this.thinking = false;
            }
          );
      } else {
        this.toastr.info('El proveedor seleccionado es el actual del contenido.');
      }
    });

  }

}
